import { jsxs, jsx } from "react/jsx-runtime";
import { useSubmitStatus } from "../../contexts/submit-status-context.js";
import { FadeOut } from "./fade-out.js";
import { SubmitErrorMessage } from "./submit-error-message.js";
import { SubmitThankYouMessage } from "./submit-thank-you-message.js";
const SubmitStatusMessage = () => {
  const { submitSuccessMessage, submitFailureCode, submitFailureMessage } = useSubmitStatus();
  return /* @__PURE__ */ jsxs("div", { role: "region", "aria-live": "polite", children: [
    /* @__PURE__ */ jsx(FadeOut, { visible: !!submitSuccessMessage, children: /* @__PURE__ */ jsx(SubmitThankYouMessage, { messageText: submitSuccessMessage }) }),
    /* @__PURE__ */ jsx(
      SubmitErrorMessage,
      {
        errorMessageCode: submitFailureCode,
        errorMessage: submitFailureMessage
      }
    )
  ] });
};
export {
  SubmitStatusMessage
};
//# sourceMappingURL=submit-status-message.js.map
